/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import industry1 from '../images/Freedom.webp'
import industry2 from '../images/Sale-Management-.webp'
import industry4 from '../images/G002-Busi-5.webp'
import '../style/stratergy.css'

const Stategry = () => {
    return (
        <>
            <div className='container' style={{ marginTop: '75px' }}>
                <h3 style={{ textAlign: 'center', color: "rgb(13, 92, 126)" }}>WHAT YOU WILL GET</h3>
                <p style={{ color: 'rgb(151 151 151)', marginTop: '10px', textAlign: 'center', fontSize: '15px' }}>You Will Have A Life-Changing Experience If You Join Us To Become The Best Version of Yourself!
                </p>
                {/* <div className='row flex-column-reverse flex-md-row' style={{ marginTop: '75px' }}>
                    <div className='col-md-4'>
                        <h3 style={{ color: 'rgb(151 151 151)', marginTop: "15px" }}>Strategy</h3>
                        <h4 style={{ color: 'rgb(13 92 126)', marginTop: '15px' }}>Adaptive. Ahead. Always.</h4>
                        <p style={{ fontSize: '18px', lineHeight: '1.4', marginTop: '15px' }}>Our strategic management consulting services are at the core of everything that we do. We help you make the big decisions necessary to succeed in today’s complex and uncertain world.</p>
                        <a href='/ContactUs' id='btnStar' style={{ border: '0px', fontSize: '18px', marginTop: '5px' }}>Contact Us
                            <img src="https://www.svgrepo.com/show/65705/right-arrow.svg" style={{ marginLeft: '10px', marginBottom: '4px' }} width={'14px'} height={'14px'} alt="arrow" />
                        </a>
                    </div>
                    <div className='col-md-8'>
                        <div className="vl"><img src={str1} alt="Strategy" className="img-fluid" /></div>
                    </div>
                </div>
                <hr />

                <div className='row flex-column-reverse flex-md-row' style={{ marginTop: '25px' }}>
                    <div className='col-md-4'>
                        <h3 style={{ color: 'rgb(151 151 151)', marginTop: "15px" }}>Digital</h3>
                        <h4 style={{ color: 'rgb(13 92 126)', marginTop: '15px' }}>Machine intelligence. Human learning.</h4>
                        <p style={{ fontSize: '18px', lineHeight: '1.4', marginTop: '15px' }}>We help you clarify your digital vision, assess your digital maturity, and build your capabilities for the new era of digitally driven business.</p>
                        <a href='/ContactUs' id='btnStar' style={{ border: '0px', fontSize: '18px', marginTop: '5px' }}>Contact Us
                            <img src="https://www.svgrepo.com/show/65705/right-arrow.svg" style={{ marginLeft: '10px', marginBottom: '4px' }} width={'14px'} height={'14px'} alt="arrow" />
                        </a>
                    </div>
                    <div className='col-md-8'>
                        <div className="vl"><img src={str2} alt="Digital" className="img-fluid" /></div>
                    </div>
                </div>
                <hr />

                <div className='row flex-column-reverse flex-md-row' style={{ marginTop: '25px' }}>
                    <div className='col-md-4'>
                        <h3 style={{ color: 'rgb(151 151 151)', marginTop: "15px" }}>Business Transformation</h3>
                        <h4 style={{ color: 'rgb(13 92 126)', marginTop: '15px' }}>Reform. Perform. Transform.</h4>
                        <p style={{ fontSize: '18px', lineHeight: '1.4', marginTop: '15px' }}>We guide you through the deep change management process that is required to bring about dramatic improvements in your business performance.</p>
                        <a href='/ContactUs' id='btnStar' style={{ border: '0px', fontSize: '18px', marginTop: '5px' }}>Contact Us
                            <img src="https://www.svgrepo.com/show/65705/right-arrow.svg" style={{ marginLeft: '10px', marginBottom: '4px' }} width={'14px'} height={'14px'} alt="arrow" />
                        </a>
                    </div>
                    <div className='col-md-8'>
                        <div className="vl"><img src={str3} alt="Digital" className="img-fluid" /></div>
                    </div>
                </div>
                <hr />

                <div className='row flex-column-reverse flex-md-row' style={{ marginTop: '25px', marginBottom: '50px' }}>
                    <div className='col-md-4'>
                        <h3 style={{ color: 'rgb(151 151 151)', marginTop: "15px" }}>Marketing and Sales</h3>
                        <h4 style={{ color: 'rgb(13 92 126)', marginTop: '15px' }}>Art. Meet science.</h4>
                        <p style={{ fontSize: '18px', lineHeight: '1.4', marginTop: '15px' }}>We help you deliver and capture more value through integrated marketing strategies, superior sales and channel management, new customer insights and innovative digital marketing efforts.</p>
                        <a href='/ContactUs' id='btnStar' style={{ border: '0px', fontSize: '18px', marginTop: '5px' }}>Contact Us
                            <img src="https://www.svgrepo.com/show/65705/right-arrow.svg" style={{ marginLeft: '10px', marginBottom: '4px' }} width={'14px'} height={'14px'} alt="arrow" />
                        </a>
                    </div>
                    <div className='col-md-8'>
                        <div className="vl"><img src={str4} alt="Digital" className="img-fluid" /></div>
                    </div>
                </div> */}

                <div className='row' style={{ marginTop: '30px' }}>
                    <div className='col-sm' style={{ margin: '10px', textAlign: 'center', borderRadius: '15px', border: '2px solid rgb(234, 236, 237)', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)' }}>
                        <img src={industry1} style={{ marginTop: '25px', width: "100px", height: '100px' }} alt="industrylogo" />
                        <p style={{ fontSize: '18px', fontFamily: 'Merriweather', marginBottom: '30px', marginTop:"15px" }}>You Unlock Secrets To Create Time & Wealth In Business</p>
                    </div>
                    <div className='col-sm' style={{ margin: '10px', textAlign: 'center', borderRadius: '15px', border: '2px solid rgb(234, 236, 237)', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)' }}>
                        <img src={industry2} style={{ marginTop: '25px', width: "100px", height: '100px' }} alt="industrylogo" />
                        <p style={{ fontSize: '18px', fontFamily: 'Merriweather', marginBottom: '30px', marginTop:"15px" }}>You Learn Strong Foundational Activities To Win In Your Business</p>
                    </div>
                    <div className='col-sm' style={{ margin: '10px', textAlign: 'center', borderRadius: '15px', border: '2px solid rgb(234, 236, 237)', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)' }}>
                        <img src={industry4} style={{ marginTop: '25px', width: "100px", height: '100px' }} alt="industrylogo" />
                        <p style={{ fontSize: '18px', fontFamily: 'Merriweather', marginBottom: '30px', marginTop:"15px" }}>Your Business Growth With Increased Revenue & Cashflow</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Stategry
